import React, { useState } from "react";
import { motion } from "framer-motion";
import { Mail, Lock, User as UserIcon } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { PasswordInput } from "./PasswordInput";

export const RegisterForm = ({ busy, onSubmit }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || password.length < 6) {
      toast.error("Fill all fields. Password must be 6+ characters.");
      return;
    }
    onSubmit({ name: name.trim(), email: email.trim().toLowerCase(), password });
  };

  return (
    <motion.form
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      onSubmit={submit}
      data-testid="auth-form"
      className="space-y-4"
    >
      <div>
        <Label className="text-[#2D3142] font-semibold flex items-center gap-2 mb-2">
          <UserIcon className="w-4 h-4 text-[#277A82]" /> Name
        </Label>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
          data-testid="auth-name-input"
          className="bg-white border-[#E2E0D8] h-12"
        />
      </div>

      <div>
        <Label className="text-[#2D3142] font-semibold flex items-center gap-2 mb-2">
          <Mail className="w-4 h-4 text-[#277A82]" /> Email
        </Label>
        <Input
          value={email}
          type="email"
          autoComplete="email"
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid="auth-email-input"
          className="bg-white border-[#E2E0D8] h-12"
        />
      </div>

      <div>
        <Label className="text-[#2D3142] font-semibold flex items-center gap-2 mb-2">
          <Lock className="w-4 h-4 text-[#277A82]" /> Password
        </Label>
        <PasswordInput
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="At least 6 characters"
          autoComplete="new-password"
        />
      </div>

      <Button
        type="submit"
        disabled={busy}
        data-testid="auth-submit-btn"
        className="w-full bg-[#277A82] hover:bg-[#1F5566] text-white h-12 mt-2"
      >
        {busy ? "Just a sec…" : "Create account"}
      </Button>
    </motion.form>
  );
};
